import { Component, OnInit, Input, OnDestroy, HostListener, ElementRef, Output, EventEmitter, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import {Observable, fromEvent, Subscription, } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { isPlatformBrowser } from '@angular/common'

@Component({
    selector: 'app-hoover-popup',
    templateUrl: './hoover-popup.component.html',
    styleUrls: ['./hoover-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HooverPopupComponent implements OnInit, OnDestroy {
  constructor(
    public logger: NGXLogger,
     @Inject(PLATFORM_ID) private platformId: object,
    private eRef: ElementRef) {
    this.logger.info('run hoover-popup contructor')
  }
  mousePosition: any = {
    x: 0,
    y: 0
  }
  @Input() additionalClasses = ''
  @Input() type = 'page'
  @Input() text = ''
  @Input() isMobile = false
  @Input() isCoapp = false
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  obsMouseEvent: Subscription
  popupVisibility = 'collapse'


  // click out of hooverpopup
  @HostListener('document:click', ['$event'])
  clickout(event) {
    // this.logger.info('clickout')
    const thatElement = this.eRef.nativeElement
    this.logger.info(this.additionalClasses)
    if (!thatElement.contains(event.target)) {
      // this.logger.info('skip')
      return
    }
    this.popupVisibility = 'collapse'
    this.closed.emit(true)
    // this.logger.info('emitting')
  }

  ngOnDestroy(): void {
    if (this.obsMouseEvent) {
      this.obsMouseEvent.unsubscribe()
    }
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (this.isMobile) {
      // this.logger.info('load mobile popup')
      this.popupVisibility =  'inherit'
    }
    else if (this.type === 'page') {
      const debouncePeriod = 100
      this.obsMouseEvent = fromEvent(document.body, 'mousemove').pipe(debounceTime(debouncePeriod)).subscribe((e: any) => {
        // this.logger.info('mousemove event')
        const popup: HTMLElement = document.getElementById('hooverPopup')

        if (!popup) {
          // this.logger.info('NO POPUP!')
          this.logger.info(document.getElementById('hooverPopup'))
          return
        }
        const pageCoef = {x: 0.025, y: 0.865}
        const otherCoef = {x: 0.23}
        const left = this.type === 'page' ? e.pageX + e.pageX * pageCoef.x : e.pageX - e.pageX * otherCoef.x
        const top = this.type === 'page' ? e.pageY - e.pageY * pageCoef.y : e.clientY
        popup.style.left = left + 'px'
        popup.style.top = top + 'px'
        this.popupVisibility =  'inherit'
      }, (error: any) => {
        console.error(error)
      })
    }
    else {
      // this.logger.info('inherit visibility')
      this.popupVisibility =  'inherit'
    }
  }

}
